export default {
  currentPassword: '',
  newPassword: '',
  confirmNewPassword: ''
};
